import Show from './show' 

export default {
    show: Show,
}